import { Checkout } from "@df/checkout/checkout.interfaces";

export namespace NSagepay {
    export enum Scripts {
        PI_FORM = 'https://pi-live.sagepay.com/api/v1/js/sagepay.js',
        PI_FORM_TEST = 'https://pi-test.sagepay.com/api/v1/js/sagepay.js'
    }

    export enum Endpoints {
        METCHANT_KEY = 'sagepay/generateMerchantKey',
        GET_REUSABLE_CARD = 'sagepay/getReusableCard',
        CLOUD_PAYMENT_SET_STORE = 'sccp/setStore',
        CLOUD_PAYMENT_RENEW_PAYMENT = 'sccp/renewPayment'
    }

    export interface IMerchantKeyResponse {
        spExpiry: string;
        spMerchantKey: string;
    }

    export interface IBrowserInfo {
        javascript_enabled: 1;
        accept_headers: 'Accept headers.';
        language?: string;
        user_agent?: string;
        java_enabled?: 1 | 0;
        color_depth?: number;
        screen_width?: number;
        screen_height?: number;
        timezone: number;
    }

    ////////////////////////////////////////////
    ///////////
    /////////// Payment methods
    ///////////
    ////////////////////////////////////////////

    export enum Methods {
        PiForm = 'sagepaysuitepi'
    }

    export interface IPiFormPaymentMethod extends Checkout.IPaymentMethod {
        ccTypes: string[];
        code: Methods.PiForm;
        isTest?: boolean;
    }

    ////////////////////////////////////////////
    ///////////
    /////////// Pi form
    ///////////
    ////////////////////////////////////////////

    export type OwnForm = (options: IOwnFormCreateOptions) => IOwnFormInstance;

    export interface IOwnFormCreateOptions {
        merchantSessionKey: string;
    }

    export interface IOwnFormInstance {
        tokeniseCardDetails(tokeniseOptions: IOwnFormTokeniseOptions): void;
        activateReusableCardIdentifier(tokeniseOptions: IActivateReusableCardIdentifierOptions): void;
    }

    export interface IActivateReusableCardIdentifierOptions {
        reusableCardIdentifier: string;
        securityCode: string;
        onActivated(result: IActivateReusableCardIdentifierResult): void;
    }

    export interface IActivateReusableCardIdentifierResult {
        success?: boolean;
    }

    export interface IOwnFormTokeniseOptions {
        cardDetails: IOwnFormTokeniseOptionsCardDetails;
        onTokenised(result: ITokeniseResult): void;
    }

    export interface IOwnFormTokeniseOptionsCardDetails {
        cardholderName: string;
        cardNumber: string;
        expiryDate: string;
        // The expiry date of the card in MMYY format
        securityCode?: string;
    }

    export interface ITokeniseResult {
        success?: boolean;
        cardIdentifier?: string;
        expiry?: string;
        cardType?: string;
        errors?: IOwnFormTokeniseError[];
        error?: string;
    }

    export interface IOwnFormTokeniseError {
        clientMessage?: string;
        message?: string;
    }

    export interface ISubmissionPaymentData<T extends ISubmissionAdditionalPaymentData> extends Checkout.ISubmissionPaymentData {
        additional_data: T;
    }

    export interface IOwnFormCheckoutSubmissionPaymentData extends ISubmissionPaymentData<IOwnFormCheckoutSubmissionAdditionalPaymentData> {
        method: Methods.PiForm;
    }

    export interface ISubmissionAdditionalPaymentData extends IBrowserInfo {
        // tokenise result
        ['card-identifier']: string;
        // merchant session key
        ['sesion-key']: string;
        cc_type: string | undefined;
    }

    export interface IOwnFormCheckoutSubmissionAdditionalPaymentData extends ISubmissionAdditionalPaymentData {
        cc_year: string | number | undefined;
        cc_month: string | number | undefined;
        cc_last_4: string;
        store_cc: boolean | number;
    }

    export interface IReusableSubmissionPaymentData extends ISubmissionPaymentData<IReusableSubmissionAdditionalPaymentData> {
        method: string;
    }

    export interface IReusableSubmissionAdditionalPaymentData extends ISubmissionAdditionalPaymentData {
        reusable: true;
    }

    export interface ICreditCardData extends Checkout.ICreditCardData {
        date?: string;
    }

    export interface IReusableCreditCardData {
        cvc: string;
    }

    export interface IGetReusableCard {
        public_hash?: string;
        card_id?: number;
    }

    ////////////////////////////////////////////
    ///////////
    /////////// Cloud payment
    ///////////
    ////////////////////////////////////////////

    export interface ICloudPaymentSetStoreData {
        store_id: number | null;
    }

    export interface ICloudPaymentRenewPaymentData {
        order_increment_id: number | string;
    }

    export interface ICloudPaymentRenewPaymentResponse {
        sccp_reference: number;
    }
}